import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { addCompanySiteUserLocationReducer, addCompanyUserLocationReducer, addSiteUserLocationReducer, addCompanySiteCategoryProductGroupProductReducer,
   addSiteUserReducer, addSiteUserHotelRoomNumberReducer } from './store/reducers/company-site-user-location.reducer';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('addCompanySiteUserLocationReducer', addCompanySiteUserLocationReducer),
    StoreModule.forFeature('addCompanyUserLocationReducer', addCompanyUserLocationReducer),
    StoreModule.forFeature('addSiteUserLocationReducer', addSiteUserLocationReducer),
    StoreModule.forFeature('addCompanySiteCategoryProductGroupProductReducer', addCompanySiteCategoryProductGroupProductReducer),
    StoreModule.forFeature('addSiteUserReducer', addSiteUserReducer),
    StoreModule.forFeature('addSiteUserHotelRoomNumberReducer', addSiteUserHotelRoomNumberReducer),

  ]
})
export class CompanySiteToStoreModule { }
